import { Spinner } from "@material-tailwind/react";

export function CustomSpinner() {
  return <Spinner className="h-16 w-16 text-gray-900/50" />;
}
